import { terminologyConfig } from '../terminology/store';
const APP_BRAND = {
    appName:     "OneFinCore",
    shortName:   "OFC",
    signinTitle: "Web App Signin",
  };
  
  const SECTION_LABELS = terminologyConfig({
    superadmin:   "Superadmin",
    admin:        "Admin",
    reseller:     "Reseller",
    client:       "client",
    enterprise:   "Enterprise",
    cases:        "cases",
    sessions:     "Sessions",
    users:        "Users",
    reports:      "Reports",
    account:      "Account",
    notify:       "Notify",
    admins:       "Admins",
    resellers:    "resellers",
    clients:      "clients",
    presentation: "Presentation",
    theme:        "Theme",
    hierarchy:    "Hierarchy",
    emailLogs:    "Email Logs",
    sampleCase:   "Sample",
    dashboard:    "Dashboard",
    userReport:       "User Report",
    commissionReport: "Commission Report",
    usageReport:      "Usage Report",
    financialReport:  "Financial Report",
  
    pageTitles: {
      cases:            null,
      sessions:         null,
      users:            null,
      reports:          null,
      account:          null,
      notify:           null,
      admins:           null,
      resellers:        null, 
      clients:          null,
      enterprise:       null,
      presentation:     null,
      userReport:       null,
      commissionReport: null,
      usageReport:      null,
      financialReport:  null,
    },
  }, {"reseller": ["reseller", "singular", "{name}"], "resellers": ["reseller", "plural", "{name}"], "client": ["client", "singular", "{name}"], "clients": ["client", "plural", "{name}"], "cases": ["case", "plural", "{name}"], "sessions": ["businessSession", "plural", "{name}"], "users": ["clientUser", "plural", "{name}"]});
  
  const URL_SEGMENTS = {
  
    // ── Role base paths ────────
    superadmin:    "superadmin",
    admin:         "admin",
    dashboard:     "dashboard",
  
    // ── Auth / public pages ────
    login:         "login",
    register:      "register",
    signin:        "signin",
    member:        "member",
    nonMembers:    "nonmembers",
    unauthorized:  "unauthorized",
    home:          "home",
    zoomConnected: "zoom-connected",
    presentation:  "presentation",
  
    // ── Dashboard section pages 
    cases:         "cases",
    viewCase:      "viewcase",   
    users:         "users",
    account:       "account",
    sampleCase:    "sample-case",
  
    // ── Session pages ──────────
    session:       "session",
    joinSession:   "join-session",
  
    // ── Case action pages ──────
    addArbitration:   "add-arbitration",
    editArbitration:  "edit-arbitration",
    addDeposition:    "add-deposition",
    editDeposition:   "edit-deposition",
    addTrial:         "add-trial",
    editTrial:        "edit-trial",
    addMediation:     "add-mediation",
    editMediation:    "edit-mediation",
    addWitnessPrep:   "add-witnessprep",
    editWitnessPrep:  "edit-witnessprep",
    addCustom:        "add-custom",
    editCustom:       "edit-custom",
    viewSession:      "session",
  
    // ── Management section pages ──
    resellers:          "resellers",        // URL here (lowercase only)
    clients:            "clients",
    enterpriseClients:  "investors-clients",
    reports:            "reports",
    notify:             "notify",
    admins:             "admins",
    terminology:        "terminology",
    theme:              "theme",
    hierarchy:          "hierarchy",
    emailLogs:          "logs",
  
    // ── Resource action URL words ──
    addClient:            "investor-add",
    editClient:           "client-edit",
    addEnterpriseClient:  "enterprise-client-add",
    editEnterpriseClient: "enterprise-client-edit",
    addReseller:          "reseller-add",
    editReseller:         "reseller-edit",
    addAdmin:             "admin-add",
    editAdmin:            "admin-edit",
    addUser:              "user-add",
    editUser:             "user-edit",
    addCase:              "team-add",
    editCase:             "team-edit",
  
    // ── Report page URL words ──
    userReport:       "userreport",
    commissionReport: "commission-report",
    usageReport:      "usage-report",
    financialReport:  "financial-report",
  };
  
  const USER_ROLES = {
  superadmin:  "superadmin",
  admin:       "admin",
  reseller:    "reseller",
  clientAdmin: "client_admin",
  enterprise:  "enterprise client",
  witness:     "witness",
  guest:       "guest",
  clientUser:  "client_user",   
};
  

  
  const resolvePageTitle = (key) =>
    (SECTION_LABELS.pageTitles[key] != null
      ? SECTION_LABELS.pageTitles[key]
      : SECTION_LABELS[key]) || key;
  
  const FULL_ROUTES = {
  
    // ── Public / auth ──────────
    login:        `/${URL_SEGMENTS.login}`,
    register:     `/${URL_SEGMENTS.register}`,
    signin:       `/${URL_SEGMENTS.signin}`,
    member:       `/${URL_SEGMENTS.member}`,
    nonMembers:   `/${URL_SEGMENTS.nonMembers}`,
    unauthorized: `/${URL_SEGMENTS.unauthorized}`,
    home:         `/${URL_SEGMENTS.home}`,
    zoomConnected:`/${URL_SEGMENTS.zoomConnected}`,
  
    // ── App entry points ───────
    session:      `/${URL_SEGMENTS.session}`,
    sessionId:    `/${URL_SEGMENTS.session}/:sessionId`,
    joinSession:  `/${URL_SEGMENTS.joinSession}`,
    presentation: `/${URL_SEGMENTS.presentation}`,
  
    // ── Role root pages ────────
    terminology:  `/${URL_SEGMENTS.superadmin}/terminology`,
    superadmin:   `/${URL_SEGMENTS.superadmin}`,
    admin:        `/${URL_SEGMENTS.admin}`,
    reseller:     `/:username`,
    clientAdmin:  `/:username/${URL_SEGMENTS.dashboard}`,
    clientUser:   `/:username/user-dashboard`,
    theme:        `/:username/${URL_SEGMENTS.theme}`,
  
    // ── Report pages ──────────
    userReport:       `/${URL_SEGMENTS.userReport}`,
    commissionReport: `/${URL_SEGMENTS.commissionReport}`,
    usageReport:      `/${URL_SEGMENTS.usageReport}`,
    financialReport:  `/${URL_SEGMENTS.financialReport}`,
  
    // ── SUPERADMIN nested child routes (relative paths) ───────────────────────
    superadminRoutes: {
      defaultRedirect:           URL_SEGMENTS.resellers,
      resellers:                 URL_SEGMENTS.resellers,
      clients:                   URL_SEGMENTS.clients,
      enterpriseClients:         URL_SEGMENTS.enterpriseClients,
      reports:                   URL_SEGMENTS.reports,
      account:                   URL_SEGMENTS.account,
      notify:                    URL_SEGMENTS.notify,
      admins:                    URL_SEGMENTS.admins,
      addClient:                 URL_SEGMENTS.addClient,
      editClient:                `${URL_SEGMENTS.editClient}/:id`,
      addEnterpriseClient:       URL_SEGMENTS.addEnterpriseClient,
      editEnterpriseClient:      `${URL_SEGMENTS.editEnterpriseClient}/:id`,
      addReseller:               URL_SEGMENTS.addReseller,
      editReseller:              `${URL_SEGMENTS.editReseller}/:id`,
      addAdmin:                  URL_SEGMENTS.addAdmin,
      editAdmin:                 `${URL_SEGMENTS.editAdmin}/:id`,
      notifyLogs:                `${URL_SEGMENTS.notify}/${URL_SEGMENTS.emailLogs}`,
      resellerHierarchy:         `${URL_SEGMENTS.resellers}/${URL_SEGMENTS.hierarchy}`,
    },
  
    // ── RESELLER nested child routes (relative paths) ─────────────────────────
    resellerRoutes: {
      defaultRedirect:           URL_SEGMENTS.clients,
      clients:                   URL_SEGMENTS.clients,
      enterpriseClients:         URL_SEGMENTS.enterpriseClients,
      reports:                   URL_SEGMENTS.reports,
      account:                   URL_SEGMENTS.account,
      addClient:                 URL_SEGMENTS.addClient,
      editClient:                `${URL_SEGMENTS.editClient}/:id`,
      addEnterpriseClient:       URL_SEGMENTS.addEnterpriseClient,
      editEnterpriseClient:      `${URL_SEGMENTS.editEnterpriseClient}/:id`,
    },
  
    // ── CLIENT / DASHBOARD nested child routes (relative paths) ───────────────
    clientRoutes: {
      defaultRedirect:           URL_SEGMENTS.cases,
      cases:                     URL_SEGMENTS.cases,
      users:                     URL_SEGMENTS.users,
      account:                   URL_SEGMENTS.account,
      
      sampleCase:       URL_SEGMENTS.sampleCase,                        // /sample-case  (loader)
      sampleCaseView:   `${URL_SEGMENTS.sampleCase}/:id`, 
  
      // Case CRUD
      addCase:                   URL_SEGMENTS.addCase,
      editCase:                  `${URL_SEGMENTS.editCase}/:id`,
      viewCase:                  `${URL_SEGMENTS.viewCase}/:id`,
  
      // User CRUD
      addUser:                   URL_SEGMENTS.addUser,
      editUser:                  `${URL_SEGMENTS.editUser}/:id`,
  
      // Session — add
      addArbitration:            `${URL_SEGMENTS.viewCase}/:caseId/${URL_SEGMENTS.addArbitration}`,
      addDeposition:             `${URL_SEGMENTS.viewCase}/:id/${URL_SEGMENTS.addDeposition}`,
      addTrial:                  `${URL_SEGMENTS.viewCase}/:id/${URL_SEGMENTS.addTrial}`,
      addMediation:              `${URL_SEGMENTS.viewCase}/:id/${URL_SEGMENTS.addMediation}`,
      addWitnessPrep:            `${URL_SEGMENTS.viewCase}/:id/${URL_SEGMENTS.addWitnessPrep}`,
      addCustomSession:          `${URL_SEGMENTS.viewCase}/:id/${URL_SEGMENTS.addCustom}/:sessionId`,
      editCustomSession:         `${URL_SEGMENTS.viewCase}/:id/${URL_SEGMENTS.editCustom}/:sessionId`,
  
      // Session — view
      viewSession:               `${URL_SEGMENTS.viewCase}/:caseId/${URL_SEGMENTS.viewSession}/:sessionId`,
  
      // Session — edit
      editDeposition:            `${URL_SEGMENTS.viewCase}/:caseId/${URL_SEGMENTS.editDeposition}/:sessionId`,
      editTrial:                 `${URL_SEGMENTS.viewCase}/:caseId/${URL_SEGMENTS.editTrial}/:sessionId`,
      editArbitration:           `${URL_SEGMENTS.viewCase}/:caseId/${URL_SEGMENTS.editArbitration}/:arbitrationId`,
      editMediation:             `${URL_SEGMENTS.viewCase}/:caseId/${URL_SEGMENTS.editMediation}/:sessionId`,
      editWitnessPrep:           `${URL_SEGMENTS.viewCase}/:caseId/${URL_SEGMENTS.editWitnessPrep}/:sessionId`,
  
      // Join session
      joinSession:               `${URL_SEGMENTS.joinSession}/:sessionId`,
    },
  
    // ── ADMIN nested child routes (relative paths) ────────────────────────────
    adminRoutes: {
      defaultRedirect:           URL_SEGMENTS.dashboard,
      dashboard:                 URL_SEGMENTS.dashboard,
      resellers:                 URL_SEGMENTS.resellers,
      clients:                   URL_SEGMENTS.clients,
      enterpriseClients:         URL_SEGMENTS.enterpriseClients,
      editEnterpriseClient:      `${URL_SEGMENTS.editEnterpriseClient}/:id`,
      addClient:                 URL_SEGMENTS.addClient,
      editClient:                `${URL_SEGMENTS.editClient}/:id`,
      admins:                    URL_SEGMENTS.admins,
      account:                   URL_SEGMENTS.account,
      notify:                    URL_SEGMENTS.notify,
      reports:                   URL_SEGMENTS.reports,
    },
  
    // ── SUPERADMIN flat / absolute routes ──────
    superadminAbsoluteRoutes: {
      notifyLogs:                `/${URL_SEGMENTS.superadmin}/${URL_SEGMENTS.notify}/${URL_SEGMENTS.emailLogs}`,
      addReseller:               `/${URL_SEGMENTS.superadmin}/${URL_SEGMENTS.addReseller}`,
      editReseller:              `/${URL_SEGMENTS.superadmin}/${URL_SEGMENTS.editReseller}/:id`,
      addClientForReseller:      `/${URL_SEGMENTS.superadmin}/reseller/:id/add-client`,
      resellerHierarchy:         `/${URL_SEGMENTS.superadmin}/${URL_SEGMENTS.resellers}/${URL_SEGMENTS.hierarchy}`,
      addClient:                 `/${URL_SEGMENTS.superadmin}/${URL_SEGMENTS.addClient}`,
      editClient:                `/${URL_SEGMENTS.superadmin}/${URL_SEGMENTS.editClient}/:id`,
      addAdmin:                  `/${URL_SEGMENTS.superadmin}/${URL_SEGMENTS.addAdmin}`,
      editAdmin:                 `/${URL_SEGMENTS.superadmin}/${URL_SEGMENTS.editAdmin}/:id`,
    },
  
    // ── ADMIN flat / absolute routes ───────────
    adminAbsoluteRoutes: {
      addReseller:               `/${URL_SEGMENTS.admin}/${URL_SEGMENTS.addReseller}`,
      editReseller:              `/${URL_SEGMENTS.admin}/${URL_SEGMENTS.editReseller}/:id`,
      addClientForReseller:      `/${URL_SEGMENTS.admin}/reseller/:id/add-client`,
      resellerHierarchy:         `/${URL_SEGMENTS.admin}/${URL_SEGMENTS.resellers}/${URL_SEGMENTS.hierarchy}`,
      addClient:                 `/${URL_SEGMENTS.admin}/${URL_SEGMENTS.addClient}`,
      editClient:                `/${URL_SEGMENTS.admin}/${URL_SEGMENTS.editClient}/:id`,
    },
  };
  
  const PAGE_TITLE_MAP = [
    { segments: [URL_SEGMENTS.account],
      get title() { return resolvePageTitle("account"); } },
    { segments: [URL_SEGMENTS.resellers, "reseller"],
      get title() { return resolvePageTitle("resellers"); } },
    { segments: [URL_SEGMENTS.enterpriseClients, "enterprise-client"],
      get title() { return resolvePageTitle("enterprise"); } },
    { segments: [URL_SEGMENTS.clients, "client"],
      get title() { return resolvePageTitle("clients"); } },
    { segments: [URL_SEGMENTS.userReport, URL_SEGMENTS.commissionReport,
                 URL_SEGMENTS.usageReport, URL_SEGMENTS.financialReport,
                 URL_SEGMENTS.reports, "report"],
      get title() { return resolvePageTitle("reports"); } },
    { segments: [URL_SEGMENTS.notify, "notification", "notifications"],
      get title() { return resolvePageTitle("notify"); } },
    { segments: [URL_SEGMENTS.admins],
      get title() { return resolvePageTitle("admins"); } },
    { segments: [URL_SEGMENTS.admin],
      get title() { return resolvePageTitle("admin"); } },
    { segments: [URL_SEGMENTS.users, "user", "usermanagement"],
      get title() { return resolvePageTitle("users"); } },
      { segments: [URL_SEGMENTS.cases, URL_SEGMENTS.viewCase,
        URL_SEGMENTS.addCase, URL_SEGMENTS.editCase, "case-management"],
          get title() { return resolvePageTitle("cases"); } },
    { segments: [URL_SEGMENTS.presentation],
      get title() { return resolvePageTitle("presentation"); } },
    { segments: [URL_SEGMENTS.session, URL_SEGMENTS.joinSession,
                 URL_SEGMENTS.addDeposition,  URL_SEGMENTS.editDeposition,
                 URL_SEGMENTS.addTrial,       URL_SEGMENTS.editTrial,
                 URL_SEGMENTS.addArbitration, URL_SEGMENTS.editArbitration,
                 URL_SEGMENTS.addMediation,   URL_SEGMENTS.editMediation,
                 URL_SEGMENTS.addWitnessPrep, URL_SEGMENTS.editWitnessPrep,
                 URL_SEGMENTS.addCustom,      URL_SEGMENTS.editCustom],
      get title() { return resolvePageTitle("sessions"); } },
  ];
  
  const EXACT_PAGE_TITLES = {
    [`/${URL_SEGMENTS.login}`]:    APP_BRAND.appName,
    [`/${URL_SEGMENTS.signin}`]:   APP_BRAND.signinTitle,
    [`/${URL_SEGMENTS.register}`]: "Register",
  };
  
  const buildPath = (routeTemplate, params = {}) =>
    Object.entries(params).reduce(
      (path, [key, val]) => path.replace(`:${key}`, encodeURIComponent(String(val))),
      routeTemplate
    );
  
  export {
    APP_BRAND,
    SECTION_LABELS,
    URL_SEGMENTS,
    USER_ROLES,
    FULL_ROUTES,
    PAGE_TITLE_MAP,
    EXACT_PAGE_TITLES,
    buildPath,
  };
  
  const RoutesConfig = {
    APP_BRAND, SECTION_LABELS, URL_SEGMENTS, USER_ROLES,
    FULL_ROUTES, PAGE_TITLE_MAP, EXACT_PAGE_TITLES, buildPath,
  };
  export default RoutesConfig;